<template>
    <div>
        <div class='tableauPlaceholder' id='viz1602838398119' style='position: relative'>
            <noscript><a href='#'><img alt=' '
                                       src='https://public.tableau.com/static/images/Ta/Tax1Percent/Tax1Per/1_rss.png'
                                       style='border: none'/></a></noscript>
            <object class='tableauViz' style='display:none;'>
                <param name='host_url' value='https://public.tableau.com/'/>
                <param name='embed_code_version' value='3'/>
                <param name='site_root' value=''/>
                <param name='name' value='Tax1Percent/Tax1Per'/>
                <param name='tabs' value='no'/>
                <param name='toolbar' value='yes'/>
                <param name='static_image'
                       value='https://public.tableau.com/static/images/Ta/Tax1Percent/Tax1Per/1.png'/>
                <param name='animate_transition' value='yes'/>
                <param name='display_static_image' value='yes'/>
                <param name='display_spinner' value='yes'/>
                <param name='display_overlay' value='yes'/>
                <param name='display_count' value='yes'/>
                <param name='language' value='en'/>
                <param name='filter' value='publish=yes'/>
            </object>
        </div>
        <div class="my-3 row">
            <div class="col-4">
                <date-picker
                    v-model="date"
                    type="date"
                    range
                    :format="changeFormat"
                    :lang="lang"
                    @input="prepareData"
                    confirm
                    placeholder="วันที่">
                </date-picker>
                <br>
                <span>*หากไม่ได้เลือกจะเป็นข้อมูลเดือนปัจจุบัน</span>
            </div>
            <div class="col-8">
                <button type="button" class="btn btn-primary my-2 my-sm-0"
                        @click="printReportExcel">
                    <icon name="file-download"></icon>
                    พิมพ์ Excel
                </button>
                &nbsp
                <button type="button" class="btn btn-primary my-2 my-sm-0"
                        @click="printReportPDF">
                    <icon name="file-download"></icon>
                    พิมพ์ PDF
                </button>
            </div>
        </div>
        <table style="text-align: center" class="table table-bordered">
            <thead>
            <tr>
                <th scope="col">ชื่อคนขับรถ</th>
                <th scope="col">เลขบัตรประชาชน</th>
                <th scope="col">ทะเบียนรถ</th>
                <th scope="col">รวมทั้งสิ้น</th>
                <th scope="col">หัก ณ ที่จ่าย 1%</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(x,i) in data">
                <tr>
                    <td>{{ x.driver.name }}</td>
                    <td>{{ x.driver.id_card }}</td>
                    <td>{{ x.driver.license_plate }}</td>
                    <td>{{ x.sum_fee + x.sum_bonus + x.sum_invoice_fee | amount }}</td>
                    <td>{{ x.sum_tax | amount }}</td>
                </tr>
                <tr v-if="i == data.length-1">
                    <td colspan="4">Grand Total</td>
                    <td>{{ grand_total | amount }}</td>
                </tr>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {domain} from "@/util/Constants";

export default {
    name: "TaxDriverReport",
    components: {
        DatePicker
    },
    data() {
        return {
            data: [],
            date: [],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.prepareData()
    },
    mounted() {
        this.initTableau();
    },
    computed: {
        grand_total() {
            return this.data.reduce((total, item) => {
                return total + (item.sum_tax ? item.sum_tax : 0);
            }, 0);
        },
    },
    methods: {
        initTableau() {
            var divElement = document.getElementById('viz1602838398119');
            var vizElement = divElement.getElementsByTagName('object')[0];
            if (divElement.offsetWidth > 800) {
                vizElement.style.width = '1400px';
                vizElement.style.height = '827px';
            } else if (divElement.offsetWidth > 500) {
                vizElement.style.width = '1400px';
                vizElement.style.height = '827px';
            } else {
                vizElement.style.width = '100%';
                vizElement.style.height = '727px';
            }
            var scriptElement = document.createElement('script');
            scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';
            vizElement.parentNode.insertBefore(scriptElement, vizElement);
        },
        prepareData() {
            let data = {
                date_start: this.date.length > 0 && this.date[0] != null ? moment(this.date[0]).format('YYYY-MM-DD') : '',
                date_end: this.date.length > 0 && this.date[1] != null ? moment(this.date[1]).format('YYYY-MM-DD') : '',
            }
            this.$store.dispatch('Driver/onePercent', data).then(res => {
                this.data = res
            })
        },
        printReportExcel() {
            let data = {
                date_start: this.date.length > 0 && this.date[0] != null ? moment(this.date[0]).format('YYYY-MM-DD') : '',
                date_end: this.date.length > 0 && this.date[1] != null ? moment(this.date[1]).format('YYYY-MM-DD') : '',
                file: 'excel'
            }
            window.open(domain + `/one_percent?date_start=${data.date_start}&date_end=${data.date_end}&file=${data.file}`)
        },
        printReportPDF() {
            let data = {
                date_start: this.date.length > 0 && this.date[0] != null ? moment(this.date[0]).format('YYYY-MM-DD') : '',
                date_end: this.date.length > 0 && this.date[1] != null ? moment(this.date[1]).format('YYYY-MM-DD') : '',
                file: 'pdf'
            }
            window.open(domain + `/one_percent?date_start=${data.date_start}&date_end=${data.date_end}&file=${data.file}`)
        }
    }
}
</script>

<style scoped>

</style>
